module.exports = "<div class=\"clearfix component-time-control form-control\"> <div style=position:relative;float:left class=time-control-wrap> <input type=time class=\"ui-calendar ui-width dynamic-form-input timeInput\"> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/time-control/time-control.wx.html
// module id = 1968
// module chunks = 50